{
  "checkIn": {
    "steps": {
      "apis": {
        "thaiDigitalArrivalCard": {
          "title": "Have you submitted the Thailand Digital Arrival Card?",
          "content": "You must submit it before entering Thailand.",
          "link": {
            "text": "Go to Arrival Card form",
            "url": "https://tdac.immigration.go.th/arrival-card/#/home"
          }
        }
      }
    }
  },
  "services": {
    "priority": {
      "paid": "{amount} x Priority services",
      "state": {
        "purchased": {
          "default": "No priority services confirmed yet",
          "plural": "{numberOfItems} Priority services confirmed",
          "singular": "1 Priority services confirmed"
        },
        "selection": {
          "default": "No priority services selected yet",
          "plural": "{numberOfItems} Priority services waiting in the cart",
          "singular": "1 Priority services waiting in the cart"
        }
      }
    }
  }
}
